import cn from 'bem-cn';
import { Skeleton, Stack } from '../../UI';

import './PromptInfoHeader.scss';

const b = cn('prompt-info-header');

export const PromptInfoHeaderSkeleton = () => {
    return (
        <Stack className={b()}>
            <Stack alignItems="center">
                <Skeleton variant="circular" width={80} height={80} />
            </Stack>
            <Stack spacing={8}>
                <Stack direction="row" justifyContent="center" className={b('categories')}>
                    <Skeleton variant="rounded" width={100} height={28} style={{ borderRadius: 100 }} />
                    <Skeleton variant="rounded" width={60} height={28} style={{ borderRadius: 100 }} />
                </Stack>
                <Stack as="h1" spacing={4} alignItems="center">
                    <Skeleton width="80%" />
                    <Skeleton width="60%" />
                </Stack>
                <Stack spacing={4} alignItems="center">
                    <Skeleton width="100%" />
                    <Skeleton width="85%" />
                    <Skeleton width="90%" />
                </Stack>
            </Stack>
        </Stack>
    );
};
